<div class="modal-overlay" *ngIf="show" (click)="onModalBackdropClick($event)">
  <div class="modal-container import-modal">
    <div class="modal-header">
      <h2>從合規判斷匯入</h2>
      <button class="modal-close" (click)="closeModal()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <!-- 選擇框區域 -->
      <div class="form-section">
        <div class="form-row">
          <!-- 主題選擇 -->
          <div class="form-group">
            <label for="importTopic">主題：</label>
            <select id="importTopic" [(ngModel)]="selectedTopic" (change)="onTopicChange()">
              <option value="">請選擇主題</option>
              <option *ngFor="let topic of availableTopics" [value]="topic">{{ topic }}</option>
            </select>
          </div>

          <!-- 任務選擇 -->
          <div class="form-group">
            <label for="importTask">任務：</label>
            <select id="importTask" [(ngModel)]="selectedTitle" (change)="onTitleChange()" [disabled]="!selectedTopic">
              <option value="">請選擇任務</option>
              <option *ngFor="let title of availableTitles" [value]="title">{{ title }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- 不符合項目列表 -->
      <div class="compliance-items-container">
        <table>
          <thead>
            <tr>
              <th class="col-select">
                <input type="checkbox"
                       [checked]="allSelected"
                       (change)="toggleSelectAll($event)"
                       [disabled]="filteredItems.length === 0">
              </th>
              <th class="col-topic">主題</th>
              <th class="col-title">任務名稱</th>
              <th class="col-assign">相關部門</th>
              <th class="col-regulation">法規資訊</th>
              <th class="col-result">判別結果</th>
              <th class="col-current-status">現況說明</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredItems">
              <td class="col-select">
                <input type="checkbox"
                       [checked]="selectedItemIds.has(item.id)"
                       (change)="toggleItemSelection(item.id)">
              </td>
              <td class="col-topic">{{ item.topic }}</td>
              <td class="col-title">{{ item.title }}</td>
              <td class="col-assign">{{ item.assign_to }}</td>
              <td class="col-regulation">
                <span [title]="item.article_content">
                  {{ item.article_id }}
                </span>
              </td>
              <td class="col-result">
                {{ item.result?.non_compliance ? '不符合' : (item.result?.compliance ? '符合' : (item.result?.irrelevant ? '無關' : '')) }}
              </td>
              <td class="col-current-status">{{ item.current_status }}</td>
            </tr>
            <tr *ngIf="filteredItems.length === 0">
              <td colspan="7">目前沒有不符合項目</td>
            </tr>
          </tbody>
        </table>

        <div class="empty-list" *ngIf="filteredItems.length === 0">
          目前沒有不符合項目
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <div class="data-count">總筆數：{{ filteredItems.length }}</div>
      <div class="selected-count">已選擇：{{ selectedItemIds.size }} 項</div>
      <div class="modal-actions">
        <button class="btn-cancel" (click)="closeModal()">取消</button>
        <button class="btn-save" (click)="importSelectedItems()" [disabled]="selectedItemIds.size === 0">
          加入追蹤項目
        </button>
      </div>
    </div>
  </div>
</div>
